import {
  ActionArm,
  ActionDisarm,
  ActionElevate,
  ActionGoto,
  ActionInspection,
  ActionLand,
  CameraGimbal,
  CameraLiveView,
  CameraShoot,
  CameraSetAutoShoot,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  ModeAuto,
  ModeLoiter,
  ModeRTL,
} from '@/define/commandSet/mavlink';

const commandGroups = [
  {
    name: 'Mode',
    commands: [ModeAuto, ModeLoiter, ModeRTL],
  },
  {
    name: 'Action',
    commands: [ActionInspection, ActionArm, ActionDisarm, ActionGoto, ActionElevate, ActionLand],
  },
  {
    name: 'Camera',
    commands: [CameraLiveView, CameraGimbal, CameraShoot, CameraSetAutoShoot],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default commandGroups;
